class Lingvo{
    constructor (id, kodo, nomo, nacinomo, fasado, vortaro)
    {
        this.id = id;
        this.kodo = kodo;
        this.nomo = nomo;
        this.nacinomo = nacinomo;
        this.fasado = fasado;
        this.vortaro = vortaro;
    }
}

export default Lingvo;